import { render, staticRenderFns } from "./APIRequestParameters.vue?vue&type=template&id=6c29280e&"
import script from "./APIRequestParameters.vue?vue&type=script&lang=ts&"
export * from "./APIRequestParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports